import { render } from "./ConfigGrid.vue?vue&type=template&id=5202f676"
import script from "./ConfigGrid.vue?vue&type=script&lang=js"
export * from "./ConfigGrid.vue?vue&type=script&lang=js"

import "./ConfigGrid.vue?vue&type=style&index=0&id=5202f676&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__